 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		213: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"ddc9f6f","1":"6ca65d3","2":"7b32ef1","3":"5228fc5","4":"5341f9a","5":"19cb13c","6":"9dfb5d4","7":"645926f","8":"c145edd","9":"8fbb66a","10":"4c622bf","11":"6a99794","12":"73ddaff","13":"909d348","14":"0def9fa","15":"e92252b","16":"13a109f","17":"d8b57c8","18":"ad08a7d","19":"39b4945","20":"c571fae","21":"26db96d","22":"686b8fc","23":"8c68ef8","24":"ba80f19","25":"270157f","26":"4c8adc1","27":"e1bcd84","28":"0457d0a","29":"de0ab62","30":"69f2648","31":"e0092cd","32":"f35e327","33":"6d64ca0","34":"0d36a73","35":"b8723ba","36":"643319f","37":"3ebc8a1","38":"9e907b6","39":"395b308","40":"43d0e42","41":"99c361e","42":"18429c3","43":"aa0d747","44":"4904de7","45":"ca32723","46":"10a635b","47":"953cd57","48":"d3aaa01","49":"859c7ec","50":"ed87eb0","51":"1a5f5f2","52":"0e653c0","53":"aa08e57","54":"a9a967c","55":"42c1cf5","56":"1ce1d61","57":"5a2fa46","58":"f68bfad","59":"5db9b40","60":"b46be91","61":"c03ebde","62":"e9ed5db","63":"6e3808b","64":"29391dd","65":"e6f11cf","66":"6b13eb9","67":"97e8033","68":"345cd6a","69":"33afeaf","70":"cca6b35","71":"e63e60a","72":"79d308a","73":"6ecfae3","74":"49d2e5c","75":"3f8b130","76":"084367a","77":"40fb315","78":"c94980c","79":"36107ee","80":"34b8312","81":"205e4cc","82":"497baa5","83":"c9d4a81","84":"4cf6c71","85":"54e4bc6","86":"a4b4f24","87":"c4ff9d9","88":"472d916","89":"7a617c9","90":"201872f","91":"f7cb15c","92":"ef7c2d2","93":"98eacc7","94":"b1bddd8","95":"ba10e5e","96":"44b0c1b","97":"a82cdde","98":"e4bbccf","99":"f8b3940","100":"11cffa5","101":"ccf8405","102":"0fe99c4","103":"7fd2c66","104":"6af4e1b","105":"64862ce","106":"426e81b","109":"7bf8ba6","110":"d7c2f58","111":"ea17b3d","112":"31ae952","113":"c8a3081","114":"af7e2ff","115":"c521b2e","116":"8121f8e","117":"83fd769","118":"fac05eb","119":"122d71a","120":"9836cdf","121":"1d901ed","122":"01b6814","123":"35476b6","124":"33e901d","125":"ef116e3","126":"dd71601","127":"ca9ffdf","128":"cb736da","129":"5635c23","130":"6bc5c03","131":"ff425eb","132":"fe21048","133":"cc89ba6","134":"edc6a31","135":"37595b4","136":"5093aac","137":"be86aa5","138":"3713842","139":"e7fa3b7","140":"a688292","141":"84112af","142":"8ee8655","143":"9e844de","144":"f3a8012","145":"f62c587","146":"1d10971","147":"65e6909","148":"980566c","149":"ee65645","150":"2e9c630","151":"afbb25a","152":"e512815","153":"d701cb0","154":"eac5b77","155":"4d5ed11","156":"0abed54","157":"7eb3a30","158":"0618417","159":"7bd77f2","160":"f6dff17","161":"d61a682","162":"5d9ebb0","163":"1a55738","164":"4c73ebf","165":"ab58e89","166":"8966af5","167":"684f64d","168":"9545085","169":"f003fdc","170":"a145d37","171":"3ff0e01","172":"1881c5f","173":"735c147","174":"e1df09e","175":"baf4e0f","176":"078c5de","177":"bfe2578","178":"36f363d","179":"fc0b965","180":"354e2b5","181":"c35f289","182":"932349f","183":"ca105e9","184":"29be85b","185":"27e24b8","186":"1edaefa","187":"f01351c","188":"151f7c4","189":"5291f59","190":"0ac80c8","191":"9f0498f","192":"6c5d626","193":"4cceb48","194":"549008b","195":"2c3735b","196":"151b32d","197":"35c014f","198":"456524f","199":"29027cd","200":"fee235a","201":"2ce18de","202":"73ede96","203":"7d41122","204":"ea13cfe","205":"30d07d0","206":"31f3577","207":"f1c2175","208":"80aae76","209":"dc39d88","210":"fc55656","211":"51c9e04","212":"383cdb7","215":"dc27005","216":"5b45e67","217":"c55f134","218":"b80f443","219":"66e61b5","220":"0c2a359","221":"104f184","222":"218d31c","223":"8d5eb19","224":"98f5dd2","225":"92afce4","226":"2cdbef1","227":"5e55864","228":"536f348","229":"e3cef1d","230":"af6fa1b","231":"9708de8","232":"2646c51","233":"eb79b60","234":"01a871a","235":"57f3a2f","236":"609735f","237":"6bad3cb","238":"a7228ca","239":"45dceb3","240":"6d0055c","241":"24f604a","242":"4974f62","243":"5f67876","244":"8ec3ec4","245":"ec9ac41","246":"1115725","247":"b4917ef","248":"c4b5019","249":"23f4971","250":"ea8bd71","251":"39d37dd","252":"66a8a15","253":"2377a67","254":"74cef6b","255":"5b15b56","256":"f65ec94","257":"30a0da2","258":"5a09587","259":"fba3fc6","260":"d5e8004","261":"56ce780","262":"4d2f77a","263":"9440dee","264":"48a87a0","265":"410fd2e","266":"edc29da","267":"950322e","268":"108178a","269":"97aa293","270":"76d408a","271":"b3c265b","272":"22e1805","273":"31ecd3b","274":"f219cc7","275":"330cc65","276":"d900333","277":"b350d47","278":"a11d331","279":"13b9d1d","280":"d6b91a9","281":"dec8025","282":"f79a177","283":"637022f","284":"468f6bb","285":"8c2c707","286":"24b2f86","287":"d0f8fb8","288":"631e7be","289":"be6209f","290":"29d4c24","291":"f1ac718","292":"378002e","293":"0aacd85","294":"7c85387","295":"8e1683d","296":"69875a7","297":"a176d07","298":"a2186fb","299":"c4ff17c","300":"bcf6fb2","301":"69de18c","302":"c6a480b","303":"074d194","304":"f15c6c2","305":"bf11d95","306":"5b107f8","307":"597f935","308":"b154549","309":"81bbe07","310":"2de9b90","311":"f2c4677","312":"cf5dcbb","313":"353d746","314":"4f03085","315":"dc8ffec","316":"532a972","317":"95f6dcd","318":"3e9ca96","319":"aee8d47","320":"3dc93d6","321":"331a4bf","322":"d4d029b","323":"f030e76"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://d2kaq61j235tiz.cloudfront.net/channels2022/220519/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
